import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { UserCurrentService } from '@shared/service/user/User.Current.Service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class UserIsSystemAdmin implements CanActivate {
    public constructor(
        private readonly _userCurrentService: UserCurrentService,
        private readonly _router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._userCurrentService.isSystemAdmin.pipe(
            map(result => {
                if (result === true) {
                    return true;
                } else {
                    return this._router.createUrlTree(['/', 'dashboard']);
                }
            })
        );
    }
}

@Injectable()
export class UserIsAdmin implements CanActivate {
    public constructor(
        private readonly _userCurrentService: UserCurrentService,
        private readonly _router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._userCurrentService.isAdmin.pipe(
            map(result => {
                if (result === true) {
                    return true;
                } else {
                    return this._router.createUrlTree(['/', 'dashboard']);
                }
            })
        );
    }
}

@Injectable()
export class UserIsInstaller implements CanActivate {
    public constructor(
        private readonly _userCurrentService: UserCurrentService,
        private readonly _router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._userCurrentService.isInstaller.pipe(
            map(result => {
                if (result === true) {
                    return true;
                } else {
                    return this._router.createUrlTree(['/', 'dashboard']);
                }
            })
        );
    }
}

@Injectable()
export class UserIsUser implements CanActivate {
    public constructor(
        private readonly _userCurrentService: UserCurrentService,
        private readonly _router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._userCurrentService.isUser.pipe(
            map(result => {
                if (result === true) {
                    return true;
                } else {
                    return this._router.createUrlTree(['/', 'dashboard']);
                }
            })
        );
    }
}

@Injectable()
export class UserIsAuthenticated implements CanActivate {
    public constructor(
        private readonly _userCurrentService: UserCurrentService,
        private readonly _router: Router) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._userCurrentService.isAuthenticated.pipe(
            map(result => {
                if (result === true) {
                    return true;
                } else {
                    return this._router.createUrlTree(['/', 'login']);
                }
            })
        );
    }
}
